var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.9,9.4c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7C14.6,10.6,13.4,9.4,11.9,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,5.6H9c-2,0-3.5,1.6-3.5,3.5V15c0,1.9,1.6,3.5,3.5,3.5h5.9c1.9,0,3.5-1.6,3.5-3.5V9.1 C18.4,7.2,16.8,5.6,14.9,5.6z M11.9,15.9c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8C15.8,14.2,14,15.9,11.9,15.9z  M16.2,8.8c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.7,8.8,16.2,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.5,15c0,2.6-2.1,4.7-4.7,4.7H9 c-2.6,0-4.7-2.1-4.7-4.7V9.1c0-2.6,2.1-4.7,4.7-4.7h5.9c2.6,0,4.7,2.1,4.7,4.7L19.5,15L19.5,15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.98a43bb494bf7034b2762c306df77156.svg";
export { ForwardRef as ReactComponent };